var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-main"},[_c('button',{staticClass:"mb-4 twn-button float-right",attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.ExportReport}},[(!_vm.loading)?_c('span',[_vm._v(" Exporter le rapport ")]):_c('span',[_vm._v(" Chargement... ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }